import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export default function Toggle({ checked, onChange, dataTip = '', disabled = false }) {
  return (
    <button onClick={onChange} type="button" data-tooltip-content={dataTip || (checked ? 'Hide' : 'Show')} disabled={disabled}>
      <FontAwesomeIcon
        icon={['fal', `toggle-o${checked ? 'n' : 'ff'}`]}
        color={checked && !disabled ? 'rgba(25,171,39,1)' : 'rgba(77,77,77,1)'}
      />
    </button>
  );
}

Toggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  dataTip: PropTypes.string,
  disabled: PropTypes.bool,
};
